import { InlineAlert } from '@systemeio/components'
import { InfoCircleIcon } from '@systemeio/icons'
import type { ReactNode } from 'react'

interface SectionMessageProps {
  children?: ReactNode
  variant?: InlineAlert.Root.Variant
  className?: string
  iconClassName?: string
  title?: ReactNode
}

function SectionMessage({
  children,
  variant,
  className,
  iconClassName,
  title,
}: SectionMessageProps) {
  return (
    <InlineAlert variant={variant} className={className}>
      <InlineAlert.Icon className={iconClassName}>
        <InfoCircleIcon aria-hidden />
      </InlineAlert.Icon>
      <InlineAlert.Content>
        {title && <InlineAlert.Title>{title}</InlineAlert.Title>}
        {children && <InlineAlert.Description>{children}</InlineAlert.Description>}
      </InlineAlert.Content>
    </InlineAlert>
  )
}

export { SectionMessage }
export type { SectionMessageProps }
